import axios from "@/components/api/axios";

const login = async credentials => {
    return await axios.post(
        '/auth/login',
        credentials)
}

const tokens = async request => {
    return await axios.post(
        '/auth/tokens',
        request)
}

export default {
    login,
    tokens
}